import { baseUrl } from "../variables/Variables";
import { fetchWithCache } from "../hooks/fetchWithCache";

// Header Search Api's
export const fetchHeaderSearch = async (searchName) => {
  const csrfToken = document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute("content");
  const settings = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify({ search_name: searchName }), // Sending search name
  };

  try {
    const response = await fetch(`${baseUrl}api/header-search`, settings);

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch search results.");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching header search results:", error);
    throw error;
  }
};

// Fetch About Us Banner
export const fetchAboutUsBanner = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const fetchResponse = await fetch(
      baseUrl + `api/fetch-about-us-banner`,
      settings
    );
    const datahttp = await fetchResponse.json();
    return datahttp;
  } catch (e) {
    console.error("Error fetching About Us Banner:", e);
    return e;
  }
};

// Fetch Take a Tour Banner
export const fetchTakeTourBanner = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const fetchResponse = await fetch(
      baseUrl + `api/fetch-hospital-tour-banner`,
      settings
    );
    const datahttp = await fetchResponse.json();
    return datahttp;
  } catch (e) {
    console.error("Error fetching About Us Banner:", e);
    return e;
  }
};

// Fetch Specialties Banner
export const fetchSpecialtiesBanner = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const fetchResponse = await fetch(
      baseUrl + `api/fetch-speciality-banner`,
      settings
    );
    const datahttp = await fetchResponse.json();
    return datahttp;
  } catch (e) {
    console.error("Error fetching Specialties Banner:", e);
    return e;
  }
};

// Fetch About Us Banner
export const fetchDoctorsBanner = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const fetchResponse = await fetch(
      baseUrl + `api/fetch-doctor-banner`,
      settings
    );
    const datahttp = await fetchResponse.json();
    return datahttp;
  } catch (e) {
    console.error("Error fetching Doctors Banner:", e);
    return e;
  }
};

// Fetch Why Choose Raheja
export const fetchWhyChooseRaheja = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const fetchResponse = await fetch(
      baseUrl + `api/fetch-why-choose-raheja`,
      settings
    );
    const datahttp = await fetchResponse.json();
    return datahttp;
  } catch (e) {
    console.error("Error fetching Why Choose Raheja:", e);
    return e;
  }
};

// Fetch Awards & Accolades
export const fetchAwardsAccolades = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const fetchResponse = await fetch(
      baseUrl + `api/fetch-about-awards-accolades`,
      settings
    );
    const datahttp = await fetchResponse.json();
    return datahttp;
  } catch (e) {
    console.error("Error fetching Awards & Accolades:", e);
    return e;
  }
};

// Fetch Career Banner
export const fetchCareerBanner = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const fetchResponse = await fetch(
      baseUrl + `api/fetch-career-banner`,
      settings
    );
    const datahttp = await fetchResponse.json();
    return datahttp;
  } catch (e) {
    console.error("Error fetching Career Banner:", e);
    return e;
  }
};

// Fetch Career At Raheja
export const fetchCareerAtRaheja = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const fetchResponse = await fetch(
      baseUrl + `api/fetch-career-at-raheja`,
      settings
    );
    const datahttp = await fetchResponse.json();
    return datahttp;
  } catch (e) {
    console.error("Error fetching About Us Banner:", e);
    return e;
  }
};

// Fetch Job Listings
export const fetchJobListings = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const fetchResponse = await fetch(baseUrl + `api/fetch-jobs`, settings);
    const datahttp = await fetchResponse.json();
    return datahttp;
  } catch (e) {
    console.error("Error fetching job listings:", e);
    return e;
  }
};

// Fetch Job Details

export const fetchJobDetails = async (slug) => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      baseUrl + `api/fetch-job-details/${slug}`,
      settings
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching job details:", error);
    throw error;
  }
};

// Fetch Career Details Banner
export const fetchCareerDetailsBanner = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const fetchResponse = await fetch(
      baseUrl + `api/fetch-career-detail-banner`,
      settings
    );
    const datahttp = await fetchResponse.json();
    return datahttp;
  } catch (e) {
    console.error("Error fetching Career Banner:", e);
    return e;
  }
};

export const createJobApplication = async (formData) => {
  const csrfToken = document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute("content");

  const settings = {
    method: "POST",
    headers: {
      Accept: "application/json",
      // "Content-Type": "application/json",
      "X-CSRF-TOKEN": csrfToken,
    },
    body: formData,
  };

  try {
    const response = await fetch(
      baseUrl + `api/apply-job-application`,
      settings
    );

    if (!response.ok) {
      // Extract error from response and throw
      const errorData = await response.json();
      throw new Error(
        errorData.error || "An error occurred while adding job application."
      );
    }

    // Parse and return JSON for successful responses
    return await response.json();
  } catch (error) {
    console.error("Error in adding job application:", error);
    throw error;
  }
};

// Fetch Health Checkup Banner
export const fetchHealthCheckupBanner = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const fetchResponse = await fetch(
      baseUrl + `api/fetch-health-checkup-banner`,
      settings
    );
    const datahttp = await fetchResponse.json();
    return datahttp;
  } catch (e) {
    console.error("Error fetching Health checkup Banner:", e);
    return e;
  }
};

// Fetch Health Checkup Details Banner
export const fetchHealthCheckupDetailsBanner = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const fetchResponse = await fetch(
      baseUrl + `api/fetch-health-checkup-details-banner`,
      settings
    );
    const datahttp = await fetchResponse.json();
    return datahttp;
  } catch (e) {
    console.error("Error fetching Health checkup details Banner:", e);
    return e;
  }
};

// Fetch Health Checkup Details
export const fetchHealthCheckupDetails = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const fetchResponse = await fetch(
      baseUrl + `api/fetch-health-checkup-details`,
      settings
    );
    const datahttp = await fetchResponse.json();
    return datahttp;
  } catch (e) {
    console.error("Error fetching health checkup details:", e);
    return e;
  }
};

// Fetch specific Health Checkup Details
export const fetchHealthCheckupDetailsBySlug = async (slug) => {
  const settings = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const fetchResponse = await fetch(
      baseUrl + `api/all-health-checkup-details/${slug}`,
      settings
    );
    const datahttp = await fetchResponse.json();
    return datahttp;
  } catch (e) {
    console.error("Error fetching health checkup details by Slug:", e);
    return e;
  }
};

// Book Health Checkup
export const submitHealthCheckupForm = async (payload) => {
  const csrfToken = document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute("content");

  const settings = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(payload),
  };

  try {
    const response = await fetch(`${baseUrl}api/book-appointment`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error submitting health checkup form:", error);
    throw error;
  }
};

// Send health checkup inquiry to CRM
export const sendHealthCheckupToCRM = async (crmData) => {
  const crmPayload = {
    first_name: crmData.name.split(" ")[0],
    last_name: crmData.name.split(" ")[1] || "",
    email: crmData.email,
    phone: crmData.phone,
    message: crmData.message,
    expected_admission_date: crmData.appointmentDate,
    leadsoruce: "SL-Raheja Website",
  };

  try {
    const response = await fetch(`${baseUrl}api/health-checkup-appointment-crm`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(crmPayload),
    });

    if (!response.ok) {
      throw new Error("Failed to send data to CRM");
    }

    return await response.json();
  } catch (error) {
    console.error("CRM Submission Error:", error);
    return { error: "CRM submission failed." };
  }
};

// Fetch Academics Banner
export const fetchAcademicsBanner = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const fetchResponse = await fetch(
      baseUrl + `api/fetch-academics-banner`,
      settings
    );
    const datahttp = await fetchResponse.json();
    return datahttp;
  } catch (e) {
    console.error("Error fetching Academics Banner:", e);
    return e;
  }
};

// Fetch Academics Overview
export const fetchAcademicsOverview = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const fetchResponse = await fetch(
      baseUrl + `api/fetch-academics-overview`,
      settings
    );
    const datahttp = await fetchResponse.json();
    return datahttp;
  } catch (e) {
    console.error("Error fetching Academics Banner:", e);
    return e;
  }
};

// Fetch Categories (Doctors / Nurses)
export const fetchAcademicCategories = async () => {
  try {
    const response = await fetch(
      `${baseUrl}api/fetch-academics-program-category`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return await response.json();
  } catch (error) {
    console.error("Error fetching academic categories:", error);
    throw error;
  }
};

// Fetch Programs by Category ID
export const fetchAcademicPrograms = async (categoryId) => {
  try {
    const response = await fetch(
      `${baseUrl}api/fetch-academics-program-details`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ academic_program_category_id: categoryId }),
      }
    );

    return await response.json();
  } catch (error) {
    console.error("Error fetching academic programs:", error);
    throw error;
  }
};

export const fetchHealthCheckupComparison = async (ids) => {
  // const token = localStorage.getItem("token");
  const settings = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ids }),
  };

  try {
    const response = await fetch(
      `${baseUrl}api/fetch-health-checkup-comparison`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching health checkup comparison:", error);
    throw error;
  }
};

// Fetch All Specialities
// export const fetchAllSpecialities = async () => {
//   const settings = {
//     method: "GET",
//     headers: {
//       Accept: "application/json",
//       "Content-Type": "application/json",
//     },
//   };

//   try {
//     const response = await fetch(
//       `${baseUrl}api/fetch-all-spcialities`,
//       settings
//     );
//     const data = await response.json();
//     return data;
//   } catch (error) {
//     console.error("Error fetching all specialties:", error);
//     throw error;
//   }
// };
let specialitiesCache = null;

export const fetchAllSpecialities = async () => {
  if (specialitiesCache) {
    return specialitiesCache;
  }

  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  return fetchWithCache("all-specialities", async () => {
    const res = await fetch(`${baseUrl}api/fetch-all-spcialities`, settings);
    if (!res.ok) throw new Error("Failed to fetch all specialities");
    return res.json();
  });
};

// Fetch Book APPOINTMENT Home cards Data
export const fetchAppointmentCardData = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/fetch-home-card-list`,
      settings
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching all specialties:", error);
    throw error;
  }
};

// Search Specialities by Name
export const searchSpecialities = async (speciality_name) => {
  const settings = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ speciality_name }),
  };

  try {
    const response = await fetch(`${baseUrl}api/search-spcialities`, settings);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error searching specialties:", error);
    throw error;
  }
};

// Specialities Details

export const fetchSpecialityDetails = async (slug) => {
  const settings = {
    method: "POST",
    headers: {
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/details-spcialities/${slug}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching speciality details:", error);
    throw error;
  }
};

// FAQ Specialty
export const fetchSpecialityFAQ = async (specialityId) => {
  const settings = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ speciality_id: Number(specialityId) }),
  };

  try {
    const response = await fetch(
      `${baseUrl}api/fetch-spaciality-faq-list`,
      settings
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Failed to fetch FAQ data.");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching FAQ data:", error);
    throw error;
  }
};

export const fetchDoctorsBySpeciality = async (speciality_id) => {
  const settings = {
    method: "POST", // Updated to POST
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ speciality_id }), // Passing speciality_id in the body
  };

  try {
    const response = await fetch(`${baseUrl}api/filter-doctors`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error fetching doctors by speciality:", error);
    throw error;
  }
};

// --- Procedures (Public) ---

export const fetchAllProcedures = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/fetch-all-procedures`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error fetching all procedures:", error);
    throw error;
  }
};

export const fetchProceduresBySpecialityId = async (specialityId) => {
  const settings = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ speciality_id: specialityId }),
  };

  try {
    const response = await fetch(`${baseUrl}api/fetch-procedures-by-speciality`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error fetching procedures by speciality:", error);
    throw error;
  }
};

export const fetchProcedureDetails = async (slug) => {
  const settings = {
    method: "POST",
    headers: {
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/details-procedure/${slug}`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error fetching procedure details:", error);
    throw error;
  }
};

export const fetchProcedureFAQ = async (procedureId) => {
  const settings = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ procedure_id: Number(procedureId) }),
  };

  try {
    const response = await fetch(`${baseUrl}api/fetch-procedure-faq-list`, settings);
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Failed to fetch procedure FAQ data.");
    }
    return await response.json();
  } catch (error) {
    console.error("Error fetching procedure FAQ data:", error);
    throw error;
  }
};

//  Fetch Spectrum of Specialties
export const fetchSpecialties = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
  };
  try {
    const response = await fetch(
      `${baseUrl}api/fetch-international-patient-page-specialty-list`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching FAQ Questions Answers:", error);
    throw error;
  }
};

// Fetch the Expert Docotor
export const fetchDoctors = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
  };

  return fetchWithCache("intl-doctors", async () => {
    const res = await fetch(
      `${baseUrl}api/fetch-international-patient-page-doctor-list`,
      settings
    );
    if (!res.ok) throw new Error("Failed to fetch international doctors");
    return res.json();
  });
};

// Fetch Faq
export const fetchFAQ = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/fetch-faq`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error fetching FAQ Questions Answers:", error);
    throw error;
  }
};

// Fetch all doctors
export const fetchAllDoctors = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/fetch-all-doctors`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error fetching all doctors:", error);
    throw error;
  }
};

// Search doctors by name
export const searchDoctors = async (doctorName) => {
  const settings = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ doctor_name: doctorName }),
  };

  try {
    const response = await fetch(`${baseUrl}api/search-doctors`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error searching doctors:", error);
    throw error;
  }
};

// Fetch Doctor Details
export const fetchDoctorDetails = async (doctorId) => {
  const settings = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ doctor_id: doctorId }),
  };

  try {
    const response = await fetch(
      `${baseUrl}api/details-doctors/${doctorId}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching doctor details:", error);
    throw error;
  }
};

// Fetch Patient Story Videos
export const fetchPatientStoryVideos = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/list-patient-story-videos`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching patient story videos:", error);
    throw error;
  }
};

// Fetch blog page Banner
export const fetchBlogBanner = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/fetch-blog-banner`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error fetching blogs:", error);
    throw error;
  }
};

// Fetch all blogs
export const fetchAllBlogs = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/fetch-all-blogs`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error fetching blogs:", error);
    throw error;
  }
};

// Fetch recent blogs
export const fetchRecentBlogs = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/fetch-recent-blogs`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error fetching recent blogs:", error);
    throw error;
  }
};

// Search blogs by title/category
export const searchBlogs = async (searchParams) => {
  const settings = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(searchParams),
  };

  try {
    const response = await fetch(`${baseUrl}api/search-blogs`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error searching blogs:", error);
    throw error;
  }
};

// Fetch blog details
export const fetchBlogDetails = async (id) => {
  const settings = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id }),
  };

  try {
    const response = await fetch(
      `${baseUrl}api/fetch-blogs-details/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching blog details:", error);
    throw error;
  }
};

// Fetch Event page Banner
export const fetchEventBanner = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/fetch-event-banner`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error fetching blogs:", error);
    throw error;
  }
};

// Fetch all events
export const fetchAllEvents = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/fetch-all-events`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error fetching events:", error);
    throw error;
  }
};

// Fetch event details
export const fetchEventDetails = async (id) => {
  const settings = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id }),
  };

  try {
    const response = await fetch(
      `${baseUrl}api/fetch-events-details/${id}`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching event details:", error);
    throw error;
  }
};

// International Patient code

// export const addInternationalPatientContact = async (formBody) => {
//     const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

//     const settings = {
//         method: "POST",
//         headers: {
//             Accept: "application/json",
//             "X-CSRF-TOKEN": csrfToken,
//         },
//         body: formBody,
//     };

//     try {
//         const response = await fetch(`${baseUrl}api/add-international-patient-contact-us`, settings);

//         if (!response.ok) {
//             const errorData = await response.json();
//             throw new Error(errorData.error || "An error occurred while submitting the form.");
//         }

//         return await response.json();
//     } catch (error) {
//         console.error("Error in add International Patient Contact:", error);
//         throw error;
//     }
// };
export const addInternationalPatientContact = async (formBody) => {
  const csrfToken = document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute("content");

  const settings = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "X-CSRF-TOKEN": csrfToken,
    },
    body: formBody,
  };

  try {
    const response = await fetch(
      `${baseUrl}api/add-international-patient-contact-us`,
      settings
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData.error || "An error occurred while submitting the form."
      );
    }

    const existingApiResponse = await response.json();

    // Convert FormData to a plain object
    const plainData = {};
    formBody.forEach((value, key) => {
      plainData[key] = value;
    });

    // Send to CRM if Laravel API succeeds
    const crmResponse = await sendToCRM({
      full_name: plainData.full_name,
      email: plainData.email,
      phone: plainData.phone,
      description: plainData.message,
      leadsource: "International Patient Contact",
    });

    return { existingApiResponse, crmResponse };
  } catch (error) {
    console.error("Error in add International Patient Contact:", error);
    throw error;
  }
};

export const sendToCRM = async (formBody) => {
  const fullName = formBody.full_name || "";
  const nameParts = fullName.split(" ");

  const crmPayload = {
    first_name: nameParts[0] || "",
    last_name: nameParts.slice(1).join(" ") || "",
    email: formBody.email,
    phone: formBody.phone,
    description: formBody.message,
    leadsource: formBody.leadsource || "Website International Page Form",
  };

  const crmHeaders = {
    "Content-Type": "application/json",
  };

  const crmApiUrl = baseUrl + `api/send-to-crm`;

  try {
    const response = await fetch(crmApiUrl, {
      method: "POST",
      headers: crmHeaders,
      body: JSON.stringify(crmPayload),
    });

    if (!response.ok) {
      throw new Error("Failed to send data to CRM");
    }

    return await response.json();
  } catch (error) {
    console.error("Error in sendToCRM:", error);
    return { error: "CRM API failed" };
  }
};

// Fetch International Patient Trusted Healthcare List
export const fetchInternationalHealthcareList = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/fetch-international-patient-trusted-healthcare`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching recent blogs:", error);
    throw error;
  }
};

// Fetch fetchInsurancePartnerList
export const fetchInsurancePartnerList = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/fetch-international-insurance-partner-list`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching recent blogs:", error);
    throw error;
  }
};

// Fetch international statics
export const fetchInternationalStatics = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/fetch-international-patient-page-facility-list`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching recent blogs:", error);
    throw error;
  }
};

// Fetch Our Services category
export const fetchOurServicesCategoryList = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/fetch-international-patient-services-category-list`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching recent blogs:", error);
    throw error;
  }
};

// Fetch Our Services Category Details

export const fetchOurServicesCategoryDetails = async (catId) => {
  const settings = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      category_id: catId,
    }),
  };

  try {
    const response = await fetch(
      `${baseUrl}api/fetch-international-patient-services-details-list`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching recent blogs:", error);
    throw error;
  }
};

// Fetch why choose us
export const fetchInternationalWhychooseus = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/fetch-international-patient-page-why-choose-us-list`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching recent blogs:", error);
    throw error;
  }
};

// Fetch fetch International Guidelines
export const fetchInternationalGuidelines = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/fetch-guideline-checklist-payment-advisory-category-list`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching recent blogs:", error);
    throw error;
  }
};

// Fetch fetch Guidelines Checklist
export const fetchGuidelinesChecklistPaymentAdvisory = async (tabId) => {
  const settings = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      guideline_category_id: tabId,
    }),
  };

  try {
    const response = await fetch(
      `${baseUrl}api/fetch-guideline-checklist-payment-advisory-details-list`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching recent blogs:", error);
    throw error;
  }
};

// Fetch OPD Banners
export const fetchOPDBanner = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/fetch-opd-banner`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error fetching recent blogs:", error);
    throw error;
  }
};

// Fetch OPD Schedule
export const fetchOPDSchedule = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(`${baseUrl}api/fetch-opd-schedule`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error fetching recent blogs:", error);
    throw error;
  }
};

// Fetch OPD Schedule Based on Specialty
export const fetchFilterOPD = async (specialityId) => {
  const settings = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ speciality_id: Number(specialityId) }),
  };

  try {
    const response = await fetch(`${baseUrl}api/filter-opd-schedule`, settings);

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Failed to fetch OPD schedule.");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching OPD schedule:", error);
    throw error;
  }
};

// Download OPD Schedule PDF
export const downloadOPDSchedulePDF = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/pdf",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/download-opd-schedule-pdf`,
      settings
    );

    if (!response.ok) {
      throw new Error("Failed to download the PDF.");
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `OPD_Schedule.pdf`;
    a.click();
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error("Error downloading PDF:", error);
    throw error;
  }
};

// Fetch All Hospital Tour Categories
export const fetchAllHospitalTourCategories = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/fetch-all-hospital-tour-category`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching hospital tour categories:", error);
    throw error;
  }
};

// Fetch All Hospital Tours
export const fetchAllHospitalTour = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await fetch(
      `${baseUrl}api/fetch-all-hospital-tour`,
      settings
    );
    return await response.json();
  } catch (error) {
    console.error("Error fetching hospital tours:", error);
    throw error;
  }
};

// Fetch Hospital Tour Details by ID
export const fetchHospitalTourDetails = async (tourId) => {
  const settings = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ tour_id: tourId }),
  };

  try {
    const response = await fetch(
      `${baseUrl}api/fetch-hospital-tour-details/${tourId}`,
      settings
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData.error || "Failed to fetch hospital tour details."
      );
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching hospital tour details:", error);
    throw error;
  }
};

// Fetch Speciality Videos List
export const fetchSpecialityVideos = async (specialityId) => {
  const settings = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ speciality_id: specialityId }),
  };

  try {
    const response = await fetch(
      `${baseUrl}api/fetch-speciality-videos-list`,
      settings
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch videos.");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching speciality videos:", error);
    throw error;
  }
};

// Fetch Docotrs Videos List
export const fetchDoctorsVideos = async (doctorsId) => {
  const settings = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ doctor_id: doctorsId }),
  };

  try {
    const response = await fetch(
      `${baseUrl}api/fetch-doctor-videos-list`,
      settings
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Failed to fetch videos.");
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching speciality videos:", error);
    throw error;
  }
};

// Add Request Call back form
// export const storeRequestCallback = async (formData) => {
//     const settings = {
//         method: "POST",
//         headers: {
//             Accept: "application/json",
//             "Content-Type": "application/json",
//         },
//         body: JSON.stringify(formData),
//     }

//     try {
//         const response = await fetch(`${baseUrl}api/store-request-callback`, settings);
//         if (!response.ok) {
//             const errorData = await response.json();
//             throw new Error(errorData.message || "Failed to submit appointment.");
//         }
//         return await response.json();
//     } catch (error) {
//         console.error("Error in Appointment:", error);
//         throw error;
//     }
// }

// OurDoctorsAdapter.js or inside PageAdapter.js

export const storeRequestCallback = async (contactData) => {
  const csrfToken = document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute("content");

  const settings = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(contactData),
  };

  try {
    // 1. Send to your backend
    const response = await fetch(
      baseUrl + `api/store-request-callback`,
      settings
    );
    if (!response.ok) {
      throw new Error("Backend API failed.");
    }
    const backendResult = await response.json();

    // 2. Send to CRM
    const crmPayload = {
      first_name: contactData.patient_name?.split(" ")[0],
      last_name: contactData.patient_name?.split(" ")[1] || "",
      phone: contactData.contact_number,
      email: contactData.email,
      message: contactData.message,
      // source: "Doctor Detail Page Form",
      source: "Customer_Portal",
      fortis_doctor_name: contactData.doctor_name,
      referred_for_specilaity: contactData.speciality_name,
      expected_admission_date: contactData.appointment_date,
      campaign_id: "7012u000000cWsGAAU",
    };

    const crmResponse = await fetch(baseUrl + `api/doctor-appointment-crm`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(crmPayload),
    });

    const crmResult = await crmResponse.json();

    return { backendResult, crmResult };
  } catch (error) {
    console.error("Error in storeRequestCallback:", error);
    throw error;
  }
};

// Add Treatment Plan and Estimate
export const addTreatmentPlanEstimate = async (formData) => {
  const settings = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  };

  try {
    const response = await fetch(
      `${baseUrl}api/add-treatment-plan-and-estimate`,
      settings
    );
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData.message || "Failed to submit treatment plan estimate."
      );
    }
    return await response.json();
  } catch (error) {
    console.error("Error in addTreatmentPlanEstimate:", error);
    throw error;
  }
};

// Fetch Technology Services About Us List
export const fetchTechnologyServicesAboutUsList = async () => {
  try {
    const response = await fetch(
      `${baseUrl}api/fetch-technology-services-about-us-list`,
      {
        method: "GET",
        headers: { Accept: "application/json" },
      }
    );

    if (!response.ok)
      throw new Error("Failed to fetch Technology Services About Us List.");
    return await response.json();
  } catch (error) {
    console.error("Error in fetchTechnologyServicesAboutUsList:", error);
    throw error;
  }
};

// Fetch Advanced Medical Equipment Details List
export const fetchAdvancedMedicalEquipmentDetailsList = async () => {
  try {
    const response = await fetch(
      `${baseUrl}api/fetch-advanced-medical-equipment-details-list`,
      {
        method: "GET",
        headers: { Accept: "application/json" },
      }
    );

    if (!response.ok)
      throw new Error(
        "Failed to fetch Advanced Medical Equipment Details List."
      );
    return await response.json();
  } catch (error) {
    console.error("Error in fetchAdvancedMedicalEquipmentDetailsList:", error);
    throw error;
  }
};

// Fetch Hospital Services Details List
export const fetchHospitalServicesDetailsList = async () => {
  try {
    const response = await fetch(
      `${baseUrl}api/fetch-hospital-services-details_list`,
      {
        method: "GET",
        headers: { Accept: "application/json" },
      }
    );

    if (!response.ok)
      throw new Error("Failed to fetch Hospital Services Details List.");
    return await response.json();
  } catch (error) {
    console.error("Error in fetchHospitalServicesDetailsList:", error);
    throw error;
  }
};

// Fetch Hospital Home Care Services List
export const fetchHospitalHomeCareServicesList = async () => {
  try {
    const response = await fetch(
      `${baseUrl}api/fetch-hospital-home-care-services-list`,
      {
        method: "GET",
        headers: { Accept: "application/json" },
      }
    );

    if (!response.ok)
      throw new Error("Failed to fetch Hospital Home Care Services List.");
    return await response.json();
  } catch (error) {
    console.error("Error in fetchHospitalHomeCareServicesList:", error);
    throw error;
  }
};

// Fetch Hospital Other Services List
export const fetchHospitalOtherServicesList = async () => {
  try {
    const response = await fetch(
      `${baseUrl}api/fetch-hospital-other-services-list`,
      {
        method: "GET",
        headers: { Accept: "application/json" },
      }
    );

    if (!response.ok)
      throw new Error("Failed to fetch Hospital Home Care Services List.");
    return await response.json();
  } catch (error) {
    console.error("Error in fetchHospitalHomeCareServicesList:", error);
    throw error;
  }
};

// Fetch International Patient Banner
export const fetchInternationalPatientBanner = async () => {
  try {
    const response = await fetch(
      `${baseUrl}api/fetch-Internatioanl-patient-banner`,
      {
        method: "GET",
        headers: { Accept: "application/json" },
      }
    );

    if (!response.ok)
      throw new Error("Failed to fetch International Patient Banner.");
    return await response.json();
  } catch (error) {
    console.error("Error in fetchInternationalPatientBanner:", error);
    throw error;
  }
};

// Fetch Health Technology Banner
export const fetchHealthTechBanner = async () => {
  try {
    const response = await fetch(
      `${baseUrl}api/fetch-technology-services-banner`,
      {
        method: "GET",
        headers: { Accept: "application/json" },
      }
    );

    if (!response.ok)
      throw new Error("Failed to fetch Health Technology Banner.");
    return await response.json();
  } catch (error) {
    console.error("Error in Health Technology Banner:", error);
    throw error;
  }
};

// Fetch Speciality Details Banner
export const fetchSpecialtyDetailsBanner = async (specialityId) => {
  try {
    const response = await fetch(
      `${baseUrl}api/fetch-speciality-details-banner/${specialityId}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok)
      throw new Error("Failed to fetch Specialty Details Banner.");

    return await response.json();
  } catch (error) {
    console.error("Error in Specialty Details Banner:", error);
    throw error;
  }
};

// Fetch Blogs by Speciality
export const fetchSpecialityBlogs = async (specialityId) => {
  const settings = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ speciality_id: specialityId }),
  };

  try {
    const response = await fetch(
      `${baseUrl}api/fetch-spaciality-blog-list`,
      settings
    );

    if (!response.ok) {
      throw new Error("Failed to fetch speciality blogs.");
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error fetching speciality blogs:", error);
    return null;
  }
};

export const fetchDoctorBlogs = async (doctorId) => {
  try {
    const response = await fetch(`${baseUrl}api/fetch-doctor-blog-list`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ doctor_id: doctorId }),
    });

    if (!response.ok) {
      throw new Error("Failed to fetch doctor blogs.");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching doctor blogs:", error);
    return null;
  }
};

// API for subscribing via Email or Phone
export const subscription = async (data) => {
  const csrfToken = document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute("content");

  try {
    const response = await fetch(`${baseUrl}api/add-subscribe`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": csrfToken,
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) throw new Error("Failed to subscribe.");

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error during subscription:", error);
    return { message: "Subscription failed." };
  }
};

// API for downloading brochure
export const downloadHealthBrochure = async () => {
  try {
    const response = await fetch(
      `${baseUrl}api/download-health-checkup-brochure`,
      {
        method: "GET",
      }
    );

    if (!response.ok) throw new Error("Failed to download brochure.");

    // Convert response to Blob
    const blob = await response.blob();

    // Create a link element for downloading
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "brochure.pdf"; // Set the file name
    document.body.appendChild(a);
    a.click();
    a.remove(); // Clean up

    window.URL.revokeObjectURL(url); // Release URL object
  } catch (error) {
    console.error("Error downloading brochure:", error);
  }
};

export const fetchSpecialityDoctors = async (speciality_id) => {
  const settings = {
    method: "POST", // Updated to POST
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ speciality_id }), // Passing speciality_id in the body
  };

  try {
    const response = await fetch(`${baseUrl}api/fetch-speciality-doctor-list`, settings);
    return await response.json();
  } catch (error) {
    console.error("Error fetching doctors by speciality:", error);
    throw error;
  }
};

export const fetchHealthDetailsBanner = async (checkupId) => {
  try {
    const response = await fetch(
      `${baseUrl}api/fetch-health-checkup-details-banner/${checkupId}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok)
      throw new Error("Failed to fetch Specialty Details Banner.");

    return await response.json();
  } catch (error) {
    console.error("Error in Specialty Details Banner:", error);
    throw error;
  }
};

/* -------------------------------------------------------
   1. Fetch Regulatory Compliance Categories
-------------------------------------------------------- */
export const fetchRegulatoryComplianceCategories = async () => {
  try {
    const response = await fetch(
      `${baseUrl}api/fetch-regulatory-complience-category-list`,
      {
        method: "GET",
        headers: { Accept: "application/json" },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch Regulatory Compliance Categories.");
    }

    return await response.json();
  } catch (error) {
    console.error("👉 Error fetching Regulatory Compliance Categories:", error);
    return { data: [] }; // Safe fallback
  }
};

/* -------------------------------------------------------
   2. Fetch Regulatory Compliance Details (ALL)
-------------------------------------------------------- */
export const fetchRegulatoryComplianceDetails = async () => {
  try {
    const response = await fetch(
      `${baseUrl}api/fetch-regulatory-complience-detail-list`,
      {
        method: "GET",
        headers: { Accept: "application/json" },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch Regulatory Compliance Details.");
    }

    return await response.json();
  } catch (error) {
    console.error("👉 Error fetching Regulatory Compliance Details:", error);
    return { data: [] }; // Safe fallback
  }
};

export const filterRegulatoryComplianceDetails = async (year, month = null) => {
  try {
    const payload = {
      year: year,
    };

    if (month) {
      payload.Month = month; // Add only if month provided
    }

    const response = await fetch(
      `${baseUrl}api/filter-bio-medical-waste-report`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to filter Regulatory Compliance Details.");
    }

    return await response.json();
  } catch (error) {
    console.error("👉 Error filtering Regulatory Compliance Details:", error);
    return { data: [] }; // Safe fallback
  }
};

// Utility: POST JSON
const postJSON = async (url, body = {}) => {
const res = await fetch(url, {
method: "POST",
headers: { "Content-Type": "application/json", Accept: "application/json" },
body: JSON.stringify(body),
});
if (!res.ok) throw new Error(`POST failed: ${url}`);
return res.json();
};


// Utility: GET JSON
const getJSON = async (url) => {
const res = await fetch(url, { method: "GET", headers: { Accept: "application/json" } });
if (!res.ok) throw new Error(`GET failed: ${url}`);
return res.json();
};

export const fetchRegulatoryComplianceBMW = async () => {
return await getJSON(`${baseUrl}api/fetch-bio-medical-waste-report`);
};

export const fetchBioMedicalWastePdfList = async () => {
return await getJSON(`${baseUrl}api/fetch-bio-medical-waste-report-pdf-file-list`);
};

export const fetchOrganTransplantReport = async () => {
return await getJSON(`${baseUrl}api/fetch-organ-transplant-report-list`);
};

export const fetchOrganTransplantCommitteeList = async () => {
return await getJSON(`${baseUrl}api/fetch-organ-transplant-committee-list`);
};

// export const filterBioMedicalWastePdfList = async (year) => {
// return await postJSON(`${baseUrl}api/filter-bio-medical-waste-report-pdf-file-list`, {
// year: Number(year),
// });
// };

export const filterBioMedicalWastePdfList = async (payload) => {
  try {
    const response = await fetch(
      `${baseUrl}api/filter-bio-medical-waste-report-pdf-file-list`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to filter BMW PDF List.");
    }

    return await response.json();
  } catch (error) {
    console.error("👉 Error filtering BMW PDF list:", error);
    return { data: [] };
  }
};

// Filter OT Report
export const filterOrganTransplantReport = async (year, month = null) => {
const payload = { year: Number(year) };
if (month) payload.Month = Number(month);
return await postJSON(`${baseUrl}api/filter-organ-transplant-report-list`, payload);
};


// ---------------------------------------------------------------------------------- //
// ------------------------ SEO API's FOR Individual Pages -------------------------- //
// ---------------------------------------------------------------------------------- //

// Helper – one‐liner factory so the code stays DRY ---------------------------
const makeSeoFetcher = (key, endpoint) =>
  async () =>
    fetchWithCache(key, async () => {
      const res = await fetch(`${baseUrl}${endpoint}`);
      if (!res.ok) throw new Error(`Failed to fetch ${key}`);
      const json = await res.json();
      return json?.data ?? null;                 // always return the `.data`
    });

// --- SEO endpoints ----------------------------------------------------------
export const fetchHomePageSeo = makeSeoFetcher("seo-home", "api/fetch-home-page-seo-data");
export const fetchAboutPageSeo = makeSeoFetcher("seo-about", "api/fetch-about-page-seo-data");
export const fetchCorporateTpaPageSeo = makeSeoFetcher("seo-corporate-tpa", "api/fetch-corporate-tpa-page-seo-data");
export const fetchInternationalPatientPageSeo = makeSeoFetcher("seo-intl-patient", "api/fetch-international-patient-page-seo-data");
export const fetchAcademicPageSeo = makeSeoFetcher("seo-academic", "api/fetch-academic-page-seo-data");
export const fetchContactPageSeo = makeSeoFetcher("seo-contact", "api/fetch-contact-page-seo-data");
export const fetchOpdSchedulePageSeo = makeSeoFetcher("seo-opd-schedule", "api/fetch-opd-schedule-page-seo-data");
export const fetchTakeATourPageSeo = makeSeoFetcher("seo-take-a-tour", "api/fetch-take-a-tour-page-seo-data");
export const fetchDoctorPageSeo = makeSeoFetcher("seo-doctor", "api/fetch-doctor-page-seo-data");
export const fetchSpecialtyPageSeo = makeSeoFetcher("seo-specialty", "api/fetch-speciality-page-seo-data");
export const fetchBlogPageSeo = makeSeoFetcher("seo-blog", "api/fetch-blog-page-seo-data");
export const fetchEventPageSeo = makeSeoFetcher("seo-event", "api/fetch-event-page-seo-data");
export const fetchCareerPageSeo = makeSeoFetcher("seo-career", "api/fetch-career-page-seo-data");
export const fetchHealthCheckupPageSeo = makeSeoFetcher("seo-health-checkup", "api/fetch-health-checkup-page-seo-data");

// export const fetchHomePageSeo = async () => {
//   try {
//     const response = await fetch(`${baseUrl}api/fetch-home-page-seo-data`);
//     const data = await response.json();
//     return data?.data || null;
//   } catch (error) {
//     console.error("Failed to fetch homepage SEO:", error);
//     return null;
//   }
// };

// // About Page SEO
// export const fetchAboutPageSeo = async () => {
//   try {
//     const response = await fetch(`${baseUrl}api/fetch-about-page-seo-data`);
//     const json = await response.json();

//     // Always return an object with `.data` key
//     return {
//       data: json?.data || {}, // fallback to empty object to avoid null
//     };
//   } catch (error) {
//     console.error("Failed to fetch About page SEO:", error);
//     return {
//       data: {}, // fallback for error case
//     };
//   }
// };

// // Corporate TPA Page SEO
// export const fetchCorporateTpaPageSeo = async () => {
//   try {
//     const response = await fetch(
//       `${baseUrl}api/fetch-corporate-tpa-page-seo-data`
//     );
//     const data = await response.json();
//     return data?.data || null;
//   } catch (error) {
//     console.error("Failed to fetch Corporate TPA page SEO:", error);
//     return null;
//   }
// };

// // International Patient Page SEO
// export const fetchInternationalPatientPageSeo = async () => {
//   try {
//     const response = await fetch(
//       `${baseUrl}api/fetch-international-patient-page-seo-data`
//     );
//     const data = await response.json();
//     return data?.data || null;
//   } catch (error) {
//     console.error("Failed to fetch International Patient page SEO:", error);
//     return null;
//   }
// };

// // Academic Page SEO
// export const fetchAcademicPageSeo = async () => {
//   try {
//     const response = await fetch(`${baseUrl}api/fetch-academic-page-seo-data`);
//     const data = await response.json();
//     return data?.data || null;
//   } catch (error) {
//     console.error("Failed to fetch Academic page SEO:", error);
//     return null;
//   }
// };

// // Contact Page SEO
// export const fetchContactPageSeo = async () => {
//   try {
//     const response = await fetch(`${baseUrl}api/fetch-contact-page-seo-data`);
//     const data = await response.json();
//     return data?.data || null;
//   } catch (error) {
//     console.error("Failed to fetch Contact page SEO:", error);
//     return null;
//   }
// };

// // OPD Schedule Page SEO
// export const fetchOpdSchedulePageSeo = async () => {
//   try {
//     const response = await fetch(
//       `${baseUrl}api/fetch-opd-schedule-page-seo-data`
//     );
//     const data = await response.json();
//     return data?.data || null;
//   } catch (error) {
//     console.error("Failed to fetch OPD Schedule page SEO:", error);
//     return null;
//   }
// };

// // Take a Tour Page SEO
// export const fetchTakeATourPageSeo = async () => {
//   try {
//     const response = await fetch(
//       `${baseUrl}api/fetch-take-a-tour-page-seo-data`
//     );
//     const data = await response.json();
//     return data?.data || null;
//   } catch (error) {
//     console.error("Failed to fetch Take a Tour page SEO:", error);
//     return null;
//   }
// };

// // Doctor Page SEO
// export const fetchDoctorPageSeo = async () => {
//   try {
//     const response = await fetch(
//       `${baseUrl}api/fetch-doctor-page-seo-data`
//     );
//     const data = await response.json();
//     return data?.data || null;
//   } catch (error) {
//     console.error("Failed to fetch Doctor page SEO:", error);
//     return null;
//   }
// };

// // specialty Page SEO
// export const fetchSpecialtyPageSeo = async () => {
//   try {
//     const response = await fetch(
//       `${baseUrl}api/fetch-speciality-page-seo-data`
//     );
//     const data = await response.json();
//     return data?.data || null;
//   } catch (error) {
//     console.error("Failed to fetch specialty page SEO:", error);
//     return null;
//   }
// };

// // Blog Page SEO
// export const fetchBlogPageSeo = async () => {
//   try {
//     const response = await fetch(
//       `${baseUrl}api/fetch-blog-page-seo-data`
//     );
//     const data = await response.json();
//     return data?.data || null;
//   } catch (error) {
//     console.error("Failed to fetch Blog page SEO:", error);
//     return null;
//   }
// };

// // Event Page SEO
// export const fetchEventPageSeo = async () => {
//   try {
//     const response = await fetch(
//       `${baseUrl}api/fetch-event-page-seo-data`
//     );
//     const data = await response.json();
//     return data?.data || null;
//   } catch (error) {
//     console.error("Failed to fetch Event page SEO:", error);
//     return null;
//   }
// };

// // Career Page SEO
// export const fetchCareerPageSeo = async () => {
//   try {
//     const response = await fetch(
//       `${baseUrl}api/fetch-career-page-seo-data`
//     );
//     const data = await response.json();
//     return data?.data || null;
//   } catch (error) {
//     console.error("Failed to fetch Career page SEO:", error);
//     return null;
//   }
// };

// // Health Checkup Page SEO
// export const fetchHealthCheckupPageSeo = async () => {
//   try {
//     const response = await fetch(
//       `${baseUrl}api/fetch-health-checkup-page-seo-data`
//     );
//     const data = await response.json();
//     return data?.data || null;
//   } catch (error) {
//     console.error("Failed to fetch Health Checkup page SEO:", error);
//     return null;
//   }
// };

// Fetch List of Corporates

export const fetchListOfTpaCorporates = async () => {
  try {
    const response = await fetch(`${baseUrl}api/fetch-corporate-list`);
    const data = await response.json();
    return data?.data || null;
  } catch (error) {
    console.error("Failed to Fetch List of Tpa corporate: ", error);
    return null;
  }
};

// Fetch List of TPA Insurance

export const fetchListOfTpaInsurance = async () => {
  try {
    const response = await fetch(`${baseUrl}api/fetch-tpa-insurance-list`);
    const data = await response.json();
    return data?.data || null;
  } catch (error) {
    console.error("Failed to Fetch List of Tpa Insurance: ", error);
  }
};


// Fetch Home Card List
export const fetchHomeCardList = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  return fetchWithCache("home-card-list", async () => {
    const res = await fetch(`${baseUrl}api/fetch-home-card-list`, settings);
    if (!res.ok) throw new Error("Failed to fetch home card list");
    return res.json();
  });
};

// Fetch Home Page About SL Raheja List
export const fetchHomePageAboutSLRahejaList = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  return fetchWithCache("home-about-slraheja", async () => {
    const res = await fetch(
      `${baseUrl}api/fetch-home-page-about-slraheja-list`,
      settings
    );
    if (!res.ok) throw new Error("Failed to fetch Home-About-SL Raheja list");
    return res.json();
  });
};

// Fetch Home Page Doctors List
export const fetchHomePageDoctorsList = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  return fetchWithCache("home-doctors-list", async () => {
    const res = await fetch(
      `${baseUrl}api/fetch-home-page-doctors-list`,
      settings
    );
    if (!res.ok) throw new Error("Failed to fetch Home Doctors list");
    return res.json();
  });
};

// Fetch Home Page Specialty List
export const fetchHomePageSpecialtyList = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  return fetchWithCache("home-specialty-list", async () => {
    const res = await fetch(
      `${baseUrl}api/fetch-home-page-specialty-list`,
      settings
    );
    if (!res.ok) throw new Error("Failed to fetch Home Specialty list");
    return res.json();
  });
};

// Fetch Home Page Corporate Logo List
export const fetchHomePageCorporateLogoList = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  return fetchWithCache("home-corporate-logo-list", async () => {
    const res = await fetch(
      `${baseUrl}api/fetch-home-page-coporate-logo-list`,
      settings
    );
    if (!res.ok) throw new Error("Failed to fetch Home Corporate Logo list");
    return res.json();
  });
};

// Fetch Home Page TPA Logo List
export const fetchHomePageTpaLogoList = async () => {
  const settings = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  return fetchWithCache("home-tpa-logo-list", async () => {
    const res = await fetch(
      `${baseUrl}api/fetch-home-page-tpa-logo-list`,
      settings
    );
    if (!res.ok) throw new Error("Failed to fetch Home TPA Logo list");
    return res.json();
  });
};

export const fetchAboutHospitalSection = async () => {
  const token = localStorage.getItem("token");

  try {
    const res = await fetch(
      `${baseUrl}api/fetch-aboutus-content-list`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    const result = await res.json();
    if (result.status === "true") {
      return result.data;
    } else {
      throw new Error(result.message || "Failed to fetch about hospital content");
    }
  } catch (error) {
    console.error("Error fetching about hospital content:", error);
    throw error;
  }
};
